<template>
  <modal
    :show="isVisible"
    :title="comboId ? t('Editar combo') : t('Adicionar combo')"
    elem-id="modal_crud_so-combos"
    size="small"
    :close-label="t('Cancelar')"
    :save-label="isSaving ? t('Salvando') : t('Salvar')"
    :save-fn="handleSave"
    @close="handleClose"
    @dismiss="handleClose"
  >
    <template v-if="isVisible">
      <s-o-combos-form
        ref="formRef"
        :combo-id="comboId"
        @submit-success="handleFormSuccess"
      />
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import SOCombosForm from './SOCombosForm.vue';

const { t } = useI18n();

const isVisible = ref<boolean>(false);
const isSaving = ref<boolean>(false);
const comboId = ref<number | null>(null);
const formRef = ref<{ handleSubmit: () => Promise<void> } | null>(null);

const handleClose = (): void => {
  isVisible.value = false;
  isSaving.value = false;
  comboId.value = null;
};

const handleSave = async (): Promise<void> => {
  isSaving.value = true;
  try {
    await formRef.value?.handleSubmit();
  } finally {
    isSaving.value = false;
  }
};

const handleFormSuccess = (): void => {
  eventBus.emit('so-combos.saved');
  handleClose();
};

const handleModalOpen = (data?: { id?: number }): void => {
  comboId.value = data?.id ?? null;
  isVisible.value = true;
};

onMounted(() => {
  eventBus.on<{ id?: number }>('modal.so-combos.open', handleModalOpen);
});

onBeforeUnmount(() => {
  eventBus.off<{ id?: number }>('modal.so-combos.open', handleModalOpen);
});
</script>
